import { useEffect, useState } from "react";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";
import Spinner from "../Reusable/Spinner";
import useGetHook from "../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useDebounce } from "../../customHooks/useDebounceHook";
import { useSearchParams } from "react-router-dom";

const DeliveryChargeTable = (props: any) => {
  const {
    localServiceBranch,
    localServiceType,
    localProductType = [],
    merchantId,
    delivery_charge_template = null,
  } = props;
  const [searchParams, setSearchParms] = useSearchParams({
    searchQuery: "",
  });
  const searchQuery = searchParams.get("searchQuery");
  const debounceSearch = useDebounce(searchQuery);

  const product_type = localProductType
    ?.map((item: any, index: number) => item?.value)
    .join(",");

  const {
    data: deliveryChargeData,
    isLoading: DeliveryChargeLoading,
    isFetching,
  } = useGetHook({
    queryKey: [
      "delivery-charge",
      `delivery-charge-${localServiceBranch}-${localServiceType}-${product_type}-${merchantId}-${debounceSearch}`,
    ],
    url: APIS.DELIVERY_CHARGE,
    params: {
      branch: localServiceBranch,
      localServiceType: localServiceType,
      product_type: product_type,
      merchant: merchantId,
      delivery_charge_template: delivery_charge_template,
      search: debounceSearch,
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [
      "delivery",
      `delivery-${localServiceBranch}-${localServiceType}-${product_type}-${merchantId}-${debounceSearch}`,
    ],
    navigateURL: "",
  });

  const handleDeliveryChargeChange = async (
    destination_city: string,
    product_type: string,
    amount: string
  ) => {
    const url = `${APIS.DELIVERY_CHARGE}`;
    let formData = {
      delivery_charge_template: delivery_charge_template,
      pickup_branch: localServiceBranch,
      destination_city: destination_city,
      merchant: merchantId,
      service_type: localServiceType,
      product_type: product_type,
      amount: amount,
    };

    try {
      await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const [rerender, setRerender] = useState(true);
  const handleSearch = (value) => {
    searchParams.set("searchQuery", value);
    setSearchParms(searchParams);
  };

  useEffect(() => {
    setRerender(!rerender);
  }, [deliveryChargeData]);

  return (
    <div className={tw`w-full overflow-auto min-h-10`}>
      <>
        <div className={tw`w-52`}>
          <input
            type="text"
            placeholder="Search"
            value={searchQuery ?? ""}
            onChange={(e) => handleSearch(e?.target?.value)}
            className={tw`border w-full border-1 border-primary focus:outline-none p-1`}
          />
        </div>
        {DeliveryChargeLoading || isFetching ? (
          <Spinner />
        ) : (
          <table>
            <thead className={tw`text-justify`}>
              <tr>
                <th className={tw`pr-12 whitespace-nowrap`}>Destination</th>
                <th className={tw`pr-12 whitespace-nowrap`}> Contact</th>

                {deliveryChargeData?.header?.map((item: any, index: number) => (
                  <th key={`product-type-${item?.id}`}>{item?.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {deliveryChargeData?.body?.map(
                (productType: any, index: number) => (
                  <tr key={`service-city${productType?.location_id}`}>
                    <td key={`service-city${productType?.location_id}`}>
                      {productType?.name}
                    </td>
                    <td
                      className={tw`pr-12`}
                      key={`service-city${productType?.location_id}`}
                    >
                      {productType?.branch_contact}
                    </td>
                    {productType?.rate?.map((item: any, index: number) => (
                      <td key={`rate-${index}`}>
                        <input
                          type="text"
                          onBlur={(event: any) =>
                            handleDeliveryChargeChange(
                              productType?.location_id,
                              deliveryChargeData?.header?.[index]?.id,
                              event?.target?.value
                            )
                          }
                          defaultValue={item}
                        />
                      </td>
                    ))}
                  </tr>
                )
              )}
            </tbody>
          </table>
        )}
      </>
    </div>
  );
};

export default DeliveryChargeTable;
